import script from "./NewCardForm.vue?vue&type=script&setup=true&lang=js"
export * from "./NewCardForm.vue?vue&type=script&setup=true&lang=js"

import "./NewCardForm.vue?vue&type=style&index=0&id=54348bd4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54348bd4"]])

export default __exports__